import { useLang } from "@/i18n/LanguageContext";

export default function Ticker() {
  const { t } = useLang();
  const items = t("ticker");
  const list = Array.isArray(items) ? items : [];
  const doubled = [...list, ...list];

  return (
    <div
      data-testid="ticker-bar"
      className="bg-[#0A0A0A] text-white overflow-hidden border-y border-neutral-800"
    >
      <div className="flex whitespace-nowrap ticker-track py-5">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="font-display font-semibold text-base md:text-xl px-8 flex items-center gap-8 tracking-tight"
          >
            {item}
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#E11D2E]" />
          </span>
        ))}
      </div>
    </div>
  );
}
